

  import React, { useState } from 'react';
import { motion } from "framer-motion";
import "./Careers.css";

export default function Careers({ 
  user, 
  formData, 
  setFormData, 
  cvFile, 
  setCvFile, 
  isSubmitting, 
  handleApply 
}) {
  const [showCareerDetails, setShowCareerDetails] = useState(false);

  // Debug: Log props to verify handleApply is received
  console.log("Careers component mounted with props:", { 
    hasHandleApply: typeof handleApply === 'function',
    handleApply: handleApply,
    isSubmitting 
  });
    
  // ========== NEW CODE ADDED ==========
  // Create local state as fallback
  const [localFormData, setLocalFormData] = useState({ firstName: "", lastName: "", email: "", message: "" });
  const [localCvFile, setLocalCvFile] = useState(null);
  
  // Use props if available, otherwise use local state
  const activeSetFormData = (typeof setFormData === 'function') ? setFormData : setLocalFormData;
  const activeFormData = (typeof setFormData === 'function') ? formData : localFormData;
  const activeSetCvFile = (typeof setCvFile === 'function') ? setCvFile : setLocalCvFile;
  const activeCvFile = (typeof setCvFile === 'function') ? cvFile : localCvFile;
  // ========== END NEW CODE ==========

  // If showing details, show ONLY the job description and form
  if (showCareerDetails) {
    return (
      <motion.div 
        initial={{ opacity: 0 }} 
        animate={{ opacity: 1 }} 
        exit={{ opacity: 0 }} 
        className="careers-details-page"
      >
        <div className="details-container">
          <button 
            onClick={() => setShowCareerDetails(false)} 
            className="back-button"
          >
            ← Back to Careers
          </button>

          <div className="jd-container">
            <h1 className="jd-main-title">Job Description: Counseling Psychologist at Nabi</h1>
            
            <p className="jd-paragraph">
              As a counsellor, you will be the first line of support for people in emotional and psychological distress who will need your strong sense of compassion and commitment to help them overcome their emotional challenges.
            </p>
            
            <p className="jd-paragraph">
              Your role will be to conduct sessions in one/few of these niches - individuals, families, groups or students explore their emotional landscape by asking what based questions and approach the issue holistically and focusing on overall well being.
            </p>
            
            <h3 className="jd-sub-title">Responsibilities:</h3>
            <ul className="jd-list">
              <li>As a counselling psychologist at Nabi, you're able to work with individuals, groups, families and students to help them with their emotional well being.</li>
              <li>Encourage clients to discuss emotions and experiences.</li>
              <li>Help clients to gain insight into their own emotional landscape by helping them explore root causes for their distress.</li>
              <li>Help clients to define their goals and plan action based on their strengths and weaknesses.</li>
              <li>Take a holistic spirit, mind, heart and body approach to their well being.</li>
              <li>Refer clients to other services like psychiatrists or clinical psychologists based on the nature and severity of their distress.</li>
              <li>Maintain confidentiality and respect the Company's privacy policy and confidentiality in terms of work and services offered.</li>
              <li>Maintain records and update notes on a regular basis.</li>
              <li>The counsellor will also be provided with training on a regular basis to improve their skills.</li>
              <li>Be open to taking feedback and giving feedback from the company to improve professional and soft skills.</li>
            </ul>
            
            <h3 className="jd-sub-title">Skills:</h3>
            <ul className="jd-list">
              <li>A graduate in Masters in Counselling Psychology with a good theoretical and subjective understanding of emotional well being and mental health support</li>
              <li>1-2 years of experience in counselling is good to have.</li>
              <li>Proactive with initiatives and ideas and has the ability to understand the needs of the users and suggest ideas to make programs of Nabi more engaging and effective</li>
              <li>Passionate about interacting and providing support and a team player and a professional who can contribute to the overall vision of the Company.</li>
            </ul>
          </div>

          <div className="application-form-section">
            <h2 className="form-heading">Interested? Get in touch.</h2>
            
            <form onSubmit={(e) => {
              e.preventDefault();
              handleApply(e, activeFormData, activeCvFile);
            }} className="application-form">
              <div className="form-row">
                <input 
                  type="text"
                  placeholder="First Name" 
                  className="form-input" 
                  value={activeFormData.firstName || ''}
                  onChange={(e) => activeSetFormData({ ...activeFormData, firstName: e.target.value })}
                  required 
                />
                <input 
                  type="text"
                  placeholder="Last Name" 
                  className="form-input" 
                  value={activeFormData.lastName || ''}
                  onChange={(e) => activeSetFormData({ ...activeFormData, lastName: e.target.value })}
                  required 
                />
              </div>
              
              <input 
                type="email" 
                placeholder="Email *" 
                className="form-input" 
                value={activeFormData.email || ''}
                onChange={(e) => activeSetFormData({ ...activeFormData, email: e.target.value })}
                required 
              />

              <div className="file-upload-container">
                <label htmlFor="cv-upload" className="upload-label">
                  {activeCvFile ? `✓ ${activeCvFile.name}` : "Upload CV"}  
                </label>
                <input 
                  id="cv-upload" 
                  type="file" 
                  style={{ display: "none" }} 
                  onChange={(e) => activeSetCvFile(e.target.files[0])}  
                  accept=".pdf,.doc,.docx"
                />
              </div>

              <textarea 
                placeholder="Message" 
                className="textarea-input" 
                value={activeFormData.message || ''}
                onChange={(e) => activeSetFormData({ ...activeFormData, message: e.target.value })}
                required 
              />
              
              <button 
                type="submit" 
                disabled={isSubmitting} 
                className="form-submit-btn"
              >
                {isSubmitting ? "Sending..." : "Send Application"}
              </button>
            </form>
          </div>
        </div>
      </motion.div>
    );
  }

  // Initial view - show hero section and job card
  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }} 
      className="careers-page"
    >
      <div className="career-hero-card">
        <motion.div
          className="career-hero-img-container"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          <img
            src="Mask group_edited_edited_edited_edited.jpg"
            alt="Careers at Nabi"
            className="career-hero-img"
          />
        </motion.div>

        <div className="career-hero-text">
          <h1 className="career-main-heading">
            Looking to make a difference?
          </h1>
          <p className="career-sub-heading">
            Join the Nabi team today, and work with us to create change.
          </p>
          <p className="career-sub-heading">
            Browse careers and open positions.
          </p>
        </div>
      </div>
      
      <div className="job-listing-container">
        <div className="job-card">
          <h3 className="job-title-text">Counseling Psychologist at Nabi</h3>
          <p className="job-description-text">
            Are you interested in making a difference in communities by providing psychological and emotional support to people in distress? Do you believe that sometimes, solutions are simple: all we need to do is ask the right questions? That's what Nabi is about.
            <br /><br />
            Empowering people to understand themselves, providing the support they need when they're emotionally distressed, and creating outlets for appropriate help.
          </p>
          <button 
            onClick={() => setShowCareerDetails(true)} 
            className="learn-more-btn"
          >
            Learn More
          </button>
        </div>
      </div>
    </motion.div>
  );
}